import React, { createContext, useContext, useState } from 'react';

type TabOption = 'preboarding-summary' | 'hired-candidates' | 'all-candidates';

interface PreboardingTabContextProps {
  selectedOption: TabOption;
  setSelectedOption: (option: TabOption) => void;
  showFilter: string;
  setShowFilter: (show: string) => void;
}

const PreboardingTabContext = createContext<PreboardingTabContextProps | undefined>(undefined);

export const usePreboardingTabContext = () => {
  const context = useContext(PreboardingTabContext);
  if (!context) {
    throw new Error('usePreboardingTabContext must be used within a PreboardingTabProvider');
  }
  return context;
};

export const PreboardingTabProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedOption, setSelectedOption] = useState<TabOption>('preboarding-summary');
  const [showFilter, setShowFilter] = useState('All Candidates');

  return (
    <PreboardingTabContext.Provider
      value={{
        selectedOption,
        setSelectedOption,
        showFilter,
        setShowFilter,
      }}
    >
      {children}
    </PreboardingTabContext.Provider>
  );
};